import src from "IMAGE";
export default { src, width: 150, height: 68, blurWidth: 0, blurHeight: 0};
